module.exports = __webpack_public_path__ + "static/media/recommendations2.be11d05f.svg";